function readToken(name, fallback) {
	if (typeof document === "undefined") return fallback
	const el = document.querySelector(".v1") || document.documentElement
	const value = getComputedStyle(el).getPropertyValue(name).trim()
	return value || fallback
}

export function buildStripeAppearance() {
	const tokens = {
		muted: readToken("--muted", "#f0f0f0"),
		foreground: readToken("--foreground", "#1a1a1a"),
		mutedForeground: readToken("--muted-foreground", "#737373"),
		border: readToken("--border", "rgba(0,0,0,0.08)"),
		primary: readToken("--primary", "#1a1a1a"),
		card: readToken("--card", "#f8f8f8"),
		destructive: readToken("--destructive", "#dc2626"),
		fontSans: readToken("--font-sans", '"Inter Variable", sans-serif'),
	}

	return {
		theme: "flat",
		variables: {
			borderRadius: "4.5px",
			colorBackground: tokens.muted,
			colorPrimary: tokens.primary,
			colorText: tokens.foreground,
			colorTextSecondary: tokens.mutedForeground,
			colorTextPlaceholder: tokens.mutedForeground,
			colorDanger: tokens.destructive,
			fontFamily: tokens.fontSans,
			fontSizeBase: "13px",
			spacingUnit: "4px",
		},
		rules: {
			".Input": {
				backgroundColor: tokens.muted,
				border: `1px solid ${tokens.border}`,
				color: tokens.foreground,
				boxShadow: "none",
				padding: "8px 12px",
				lineHeight: "1.5",
			},
			".Input:focus": {
				border: `1px solid ${tokens.primary}`,
				boxShadow: "none",
				outline: "none",
			},
			".Input--invalid": {
				border: `1px solid ${tokens.destructive}`,
			},
			".Label": {
				color: tokens.mutedForeground,
				fontWeight: "500",
				fontSize: "11px",
				letterSpacing: "0.01em",
			},
			".Tab": {
				backgroundColor: tokens.muted,
				border: `1px solid ${tokens.border}`,
				color: tokens.foreground,
			},
			".Tab:hover": {
				backgroundColor: tokens.card,
			},
			".Tab--selected": {
				backgroundColor: tokens.card,
				border: `1px solid ${tokens.primary}`,
				color: tokens.foreground,
			},
		},
	}
}
